function genUrl(...args) {
  return args.reduce(function(acc, cur, index) {
    if (index === 0) return cur;
    if (acc.endsWith('/')) {
      return acc + cur;
    }
    return acc + '/' + cur;
  }, '');
}

export default genUrl;
